import { ProForm, ProFormItem, ProFormText } from '@ant-design/pro-components'
import { Button } from 'antd'
import Cookies from 'js-cookie'
import { Navigate, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchUserInfoAsync } from '@/store/reducers/userSlice'
import { getDefaultHomePath } from '@/constants/menuPermission'
import type { LoginReq } from '@/service/login/type/login'
import styles from '@/pages/login/index.module.css'
import logo from '@/assets/images/logo.jpg'
import loginIcon from '@/assets/images/login-icon.jpg'
import userIcon from '@/assets/images/user-icon.jpg'
import passwordIcon from '@/assets/images/password-icon.jpg'
import { gateway } from './client'

async function performSilentAidoLogin(username: string, password: string) {
  const response = await fetch('https://combine-next.jarvisbro.com/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  })
  if (!response.ok) throw new Error('Login failed')

  const data = await response.json()
  if (data.code !== 200 || data.status !== 'OK') throw new Error(data.status || 'Login failed')
  if (data.data?.token) {
    localStorage.setItem('business_web_token', data.data.token)
    Cookies.set('vue_admin_template_token', data.data.token)
  }
}

export default function NextLogin() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  if (Cookies.get('access_token')) return <Navigate to="/" replace />

  return (
    <div className={styles.login}>
      <div className={styles.login_main}>
        <div>
          <div className={styles.login_content}>
            <img className={styles.login_logo} src={logo} alt="" />
            <ProForm<LoginReq>
              className={styles.pro_form}
              submitter={{ render: () => null }}
              onFinish={async values => {
                await gateway.login(values.username, values.password)
                Cookies.set('username', values.username)
                Cookies.set('password', values.password)

                try {
                  await performSilentAidoLogin(values.username, values.password)
                } catch (error) {
                  console.error('AIDO平台静默登录失败:', error)
                }

                const previousUsername = localStorage.getItem('current_username')
                if (previousUsername && previousUsername !== values.username) {
                  localStorage.setItem('need_refresh_bot_list', 'true')
                }
                localStorage.setItem('current_username', values.username)

                try {
                  const userInfo = await dispatch(fetchUserInfoAsync() as any).unwrap()
                  navigate(getDefaultHomePath(userInfo.menus, userInfo))
                } catch {
                  navigate('/bots')
                }
              }}
            >
              <ProFormText
                width="300"
                name="username"
                label="Username"
                placeholder="Please Enter Username"
                fieldProps={{
                  size: 'large',
                  style: { backgroundColor: '#121417', color: '#E5E8EF', border: '1px solid #2A2D36', marginTop: '-7px' },
                  prefix: <img src={userIcon} className="prefixIcon" style={{ width: 16, height: 16, marginRight: 8 }} />,
                }}
              />
              <ProFormText.Password
                width="300"
                name="password"
                label="Password"
                placeholder="Please Enter Your Password"
                fieldProps={{
                  size: 'large',
                  style: { backgroundColor: '#121417', color: '#E5E8EF', border: '1px solid #2A2D36', marginTop: '-7px' },
                  prefix: <img src={passwordIcon} className="prefixIcon" style={{ width: 16, height: 16, marginRight: 8 }} />,
                }}
              />
              <ProFormItem>
                <Button className={styles.login_btn} type="primary" htmlType="submit" style={{ width: 300 }}>
                  Log In
                  <img src={loginIcon} alt="" style={{ marginLeft: 10, width: 20, height: 20 }} />
                </Button>
              </ProFormItem>
            </ProForm>
          </div>
        </div>
      </div>
    </div>
  )
}
